module.exports = __webpack_public_path__ + "static/img/policy-footer_768.5e3e14c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-footer_768.png
// module id = T4Yf
// module chunks = 0